import { useState } from 'react'
import { useFetcher } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { type Project } from 'api-client'

import { qrynConfigQuery, UPDATE_DRILLDOWN } from '~/entities/integrations/qryn'

type Options = {
  projectId: Project['id']
  projectSlug: Project['slug']
}
export function useQrynDrilldown({ projectSlug, projectId }: Options) {
  const { data: config } = useQuery(qrynConfigQuery(projectId))

  const [drilldownEnabled, setDrilldownEnabled] = useState(config?.useDrilldown ?? false)

  const fetcher = useFetcher()

  const handleDrilldownToggle = (enabled: boolean): void => {
    setDrilldownEnabled(prev => (prev ? false : true))

    fetcher.submit(
      { intent: UPDATE_DRILLDOWN, enabled },
      {
        method: 'post',
        action: `/${projectSlug}/stack/qryn`,
        encType: 'application/x-www-form-urlencoded',
      },
    )
  }

  return {
    drilldownEnabled,
    handleDrilldownToggle,
  }
}
